class FsrQuantitySelector extends HTMLElement {
    constructor() {
        super();
        this.attachSelectors();
        this.attachListeners();
        this.updateMinusButtonVisibility(); // Ensure correct initial state
    }

    attachSelectors() {
        this.quantityButtons = this.querySelectorAll('.fsr-quantity');
        this.incrementButton = this.querySelector('.three-or-more .fsr-quantity-buttons.plus');
        this.decrementButton = this.querySelector('.three-or-more .fsr-quantity-buttons.minus');
        this.threeOrMoreButton = this.querySelector('.three-or-more');
        this.threeOrMoreValue = this.querySelector('.three-or-more-value');
        this.standardQuantitySelector = document.querySelector('.fsr-product-info__quantity-selector');
        this.quantityInput = this.standardQuantitySelector.querySelector('input');
    }

    attachListeners() {
        this.quantityButtons.forEach(button => {
            button.addEventListener('click', e => {
                if (!e.target.classList.contains('fsr-quantity-buttons')) {
                    this.updateActiveButton(e.target);
                    let quantity;
                    if (e.target.classList.contains('one')) {
                        quantity = 1;
                    } else if (e.target.classList.contains('two')) {
                        quantity = 2;
                    } else if (e.target.classList.contains('three-or-more')) {
                        quantity = parseInt(this.threeOrMoreValue.innerText); // Adjusted to use the span value
                    } else {
                        quantity = parseInt(this.quantityInput.value);
                    }
                    this.setQuantity(quantity);
                    this.updateMinusButtonVisibility();
                }
            });
        });

        this.incrementButton.addEventListener('click', () => this.adjustQuantity(1, this.threeOrMoreButton));
        this.decrementButton.addEventListener('click', () => this.adjustQuantity(-1, this.threeOrMoreButton));
    }

    adjustQuantity(change, button) {
        let currentQuantity = parseInt(this.threeOrMoreValue.innerText);
        currentQuantity += change;
        currentQuantity = Math.max(3, currentQuantity);
        this.threeOrMoreValue.innerText = currentQuantity;
        this.setQuantity(currentQuantity);
        this.updateActiveButton(button);
        this.updateMinusButtonVisibility();
    }

    setQuantity(quantity) {
        this.quantityInput.value = quantity;
        document.dispatchEvent(new CustomEvent('fsr:quantity:changed'));
        this.updateMinusButtonVisibility(); // Ensure visibility is updated when quantity is set
    }

    updateActiveButton(clickedButton) {
        this.quantityButtons.forEach(button => {
            button.classList.remove('active-quantity');
        });
        clickedButton.classList.add('active-quantity');
    }

    updateMinusButtonVisibility() {
        let currentQuantity = parseInt(this.threeOrMoreValue.innerText);
        if (currentQuantity > 3) {
            this.decrementButton.style.opacity = '1';
            this.decrementButton.style.display = 'inline-block';
        } else {
            this.decrementButton.style.opacity = '0';
            // Consider changing to 'none' to remove from layout
            this.decrementButton.style.display = 'none';
        }
    }
}

customElements.define('fsr-quantity-selector', FsrQuantitySelector);
